<script lang="ts">
	import type { PoiImages } from '$lib/components/pois/types';
	import type { ClassValue } from 'svelte/elements';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		images?: PoiImages;
		href?: string;
		title?: string;
		isLoading?: boolean;
		dataTestId?: string;
		class?: ClassValue;
		onclick?: () => void;
	}

	const {
		images,
		isLoading = false,
		dataTestId = 'zoi-card',
		title,
		href = '',
		onclick,
		class: classes,
	}: Props = $props();
</script>

<li
	class={['zoi-card list-reset h-40 w-59 min-w-59 grid relative overflow-hidden border-1 rd-xl border-neutral-weakest shadow-smooth-block', classes]}
	style={isLoading && !images ? '' : `--zoi-card-background: url(${images?.w320})`}>
	<Link
		{href}
		button="filled"
		color="light"
		label={m.zoi_card__see_on_map()}
		class={['h-40 w-59 min-w-59 flex items-end flex-nowrap justify-start bg-transparent text-neutral-weakest z-1', isLoading ? 'p-0' : 'p-3']}
		{onclick}
		{dataTestId}
	>
		{#if isLoading}
			<SkeletonBlock height="100%" width="100%" borderRadius="0" />
		{:else if title}
			<span
				class={['zoi-title text-md font-600 clamp-lines-3 relative']}
				aria-label={title}>
				{title}
			</span>
		{/if}
	</Link>
</li>

<style>
	.zoi-card {
		grid-template-areas: "item";
		&::before {
			content: '';
			grid-area: item;
			z-index: 0;
			background: linear-gradient(180deg, rgba(29, 49, 64, 0) 37.11%, rgba(29, 49, 64, 0.8) 100%), var(--zoi-card-background) center / cover no-repeat;
			transition: transform 300ms cubic-bezier(0, 0, 0.5, 1);
		}
	}

	.zoi-card :global(> *) {
		grid-area: item;
	}

	.zoi-card:hover {
		&::before {
			transform: scale(1.1);
		}

		& .zoi-title {
			text-decoration: underline;
		}
	}

	.zoi-title {
		&::after {
			--uno: icon-east;
			content: '';
			inset-inline-end: 0;
			display: inline-block;
			vertical-align: bottom;
			margin-left: 0.25rem;
		}
	}
</style>
